import { EntityStateCounts } from '@hospitality-bot/admin/library';
import { EntityState } from '@hospitality-bot/admin/shared';
import { CategoryType } from '@hospitality-bot/entity';

export type MenuItemListResponse = {
  records: MenuItemResponse[];
  total: number;
  entityStateCounts: EntityState<string>;
  entityTypeCounts: EntityState<string>;
};

export type MenuItemResponse = MenuItemForm & {
  id: string;
  code?: string;
  offers: OfferResponse[];
};

export type MenuItemForm = {
  name: string;
  description: string;
  mealPreference: MealPreferences;
  category: string;
  categoryName: string;
  // type: string;
  preparationTime: number;
  quantity: number;
  unit: string;
  dineInPrice: number;
  dineInPriceCurrency: string;
  deliveryPrice: number;
  deliveryPriceCurrency: string;
  hsnCode: string;
  taxes?: TaxData[];
  status: boolean;
  imageUrl: string;
  itemCode: string;
  popular: boolean;
};

export enum MealPreferences {
  ALL = 'ALL',
  VEG = 'VEG',
  NON_VEG = 'NON_VEG',
}

export type OfferResponse = {
  id: string;
  name: string;
  description: string;
  rate: number;
  startDate: number;
  endDate: number;
  active: boolean;
  packageCode: string;
  imageUrl: { isFeatured: boolean; url: string }[];
  source: string;
  entityId: string;
  autoAccept: boolean;
  hasChild: boolean;
  discountType: string;
  discountValue: number;
  discountedPrice: number;
  subPackages: any[];
  roomTypes: any[];
  foodItems: {
    category: string;
    deliveryPrice: number;
    description: string;
    dineInPrice: number;
    entityId: string;
    hsnCode: string;
    id: string;
    mealPreference: string;
    name: string;
    preparationTime: number;
    quantity: number;
    status: boolean;
    type: string;
    unit: string;
    currency: string;
  }[];
  enableOnMicrosite: boolean;
  priority: string;
  validity: string;
  redemptionCount: number;
  propertyOffer: boolean;
};

export type TaxData = {
  category: string;
  country: string;
  created: number;
  id: string;
  status: boolean;
  taxType: string;
  taxValue: number;
  updated: number;
};

export type MenuListResponse = {
  total: number;
  entityStateCounts: EntityState<string>;
  records: MenuResponse[];
};

export type MenuResponse = {
  id: string;
  code: string;
  name: string;
  imageUrl: string;
  description: string;
  status: boolean;
  entityId: string;
};

export type MenuFormData = {
  name: string;
  imageUrl: string;
  description: string;
  status: string;
};

export type MenuItemCategory = {
  name: string;
  type: CategoryType;
  active: boolean;
  source: number;
};
